import React, { useState } from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";
import IconButton from "material-ui/IconButton";
import Grid from "material-ui/Grid";
import CopperInt from "./copperInt";
import OpticalInt from "./opticalInt";
import WiFiInt from "./wifiInt";
import WiFiScannedAPs from "./wifiScannedAPs";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
const InterfaceTab = props => {
  const [zoomed, setZoomed] = useState(false);
  let mainData = props.subtestStatsResults.interfaces.find(item => {
    return item.rh === false;
  });
  let heading = props.translate("eth_link_info");
  if (mainData) {
    if (mainData.wifi) {
      heading = props.translate("wifi_connection_info");
    }
    else if (mainData.optical) {
      heading = props.hideLinkStatus ? props.translate("sfp_info") : props.translate("optical_link_info");
    }
  }
  if (props.hideMainRemote) {
    return (
      <Grid container spacing={40}>
        <Grid item xs={6}>
          {!zoomed && (
          <Typography className={props.classes.heading} color="inherit">
            {heading}
          </Typography>
          )}
          
          <div style={{height: "10pt"}}></div>
          {mainData && mainData.type == "Eth" && mainData.eth && !zoomed ? (
            <CopperInt isNavitek={props.isNavitek} data={mainData} translate={props.translate} blackbirdInterface={true} />
          ) : (
              mainData && mainData.optical && !zoomed ? <OpticalInt data={mainData} translate={props.translate} hideLinkStatus={props.hideLinkStatus} />
                : mainData && mainData.wifi && !zoomed ? <WiFiInt data={mainData} translate={props.translate} />
                : null
            )}

          {mainData && mainData.wifi && props.isNavitek ? (<div>
          <IconButton 
            className={props.classes.zoom_button} 
            onClick={() => setZoomed(!zoomed)}
          >
            <span>
              {zoomed ? "-": "+"}
            </span>  
          </IconButton>
          
          <div className={props.classes.image_container}>
            <Typography className={props.classes.heading} color="inherit">
              {props.translate("channel_analysis")}
            </Typography>
            <div className={zoomed ? props.classes.div_image_zoomed : props.classes.div_image}>
              {mainData && mainData.wifi && mainData.wifi.wifianalyzerurl && (
                <img
                  alt="Channel Analysis"
                  src={mainData.wifi.wifianalyzerurl}
                  style={{
                    width: "100%",
                    height: "150%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          </div>

          <div className={props.classes.image_container}>
            <Typography className={props.classes.heading} color="inherit">
              {props.translate("channel_utilization")}
            </Typography>
            <div className={zoomed ? props.classes.div_image_zoomed : props.classes.div_image}>
              {mainData && mainData.wifi && mainData.wifi.wifiutilizationurl && (
                <img
                  alt="Channel Utilization"
                  src={mainData.wifi.wifiutilizationurl}
                  style={{
                    width: "100%",
                    height: "150%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          </div>

          <div className={props.classes.image_container}>
            <Typography className={props.classes.heading} color="inherit">
              {props.translate("devices_per_channel")}
            </Typography>
            <div className={zoomed ? props.classes.div_image_zoomed : props.classes.div_image}>
              {mainData && mainData.wifi && mainData.wifi.wifidevicecounturl && (
                <img
                  alt="Devices per Channel"
                  src={mainData.wifi.wifidevicecounturl}
                  style={{
                    width: "100%",
                    height: "150%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          </div>
          </div>) : (<div></div>)}
            
        </Grid>
        {mainData && mainData.wifi && mainData.aps && !zoomed && (
        <Grid item xs={6}>
          <Typography className={props.classes.heading} color="inherit">
            {props.translate("wifi_scanned_aps")}
          </Typography>
          <WiFiScannedAPs data={mainData} translate={props.translate} />
        </Grid>
        )}
    </Grid>
    );
  }
  let remoteData = props.subtestStatsResults.interfaces.find(item => {
    return item.rh === true;
  });
  return (
    <Grid container spacing={40}>
      <Grid item xs={6}>
        <Typography className={props.classes.heading} color="inherit">
          {props.translate("results_chart_display")}
        </Typography>
        {mainData && mainData.type == "Eth" && mainData.eth ? (
          <CopperInt isNavitek={props.isNavitek} data={mainData} translate={props.translate} />
        ) : (
            mainData && mainData.optical ? <OpticalInt data={mainData} translate={props.translate} /> : null
          )}
      </Grid>
      <Grid item xs={6}>
        <Typography className={props.classes.heading} color="inherit">
          {props.translate("results_chart_remote")}
        </Typography>
        {remoteData && remoteData.type === "Eth" && remoteData.eth ? (
          <CopperInt isNavitek={false} data={remoteData} translate={props.translate} />
        ) : (
          remoteData && remoteData.optical ? <OpticalInt data={remoteData} translate={props.translate} /> : null
          )}
      </Grid>
    </Grid>
  );
};
export default withStyles(styles)(InterfaceTab);
